"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const timers_1 = require("timers");
exports.handleAlertOptionsModalDisplay = (deviceInfoSelected) => (dispatch) => {
    if (deviceInfoSelected.length !== 0) {
        dispatch({
            type: 'SET_ALERT_OPTIONS_MODAL_OPEN',
            deviceInfoSelected,
        });
    }
    else {
        dispatch({
            type: 'SET_ALERT_OPTIONS_MODAL_CLOSING',
            deviceInfoSelected: 'close',
        });
        timers_1.setTimeout(() => {
            dispatch({
                type: 'SET_ALERT_OPTIONS_MODAL_CLOSED',
                deviceInfoSelected,
            });
        }, 500);
    }
};
